import { createContext, useContext } from 'react';

export const ApiAuthContext = createContext(false);

/**
 * Returns true once the API client has been configured with an auth token provider.
 * Use this to gate React Query hooks so they don't fire before auth is ready.
 */
export function useApiReady(): boolean {
  return useContext(ApiAuthContext);
}
